import { Brand } from '@/components/Brand'
import { MetaPhaseLink } from '@/components/MetaPhaseLink'

interface FooterSection {
  title: string
  links: ReadonlyArray<{ to: string; label: string }>
}

const SECTIONS: ReadonlyArray<FooterSection> = [
  {
    title: 'Product',
    links: [
      { to: '/explore', label: 'Explore' },
      { to: '/api',     label: 'API' },
      { to: '/docs',    label: 'Docs' },
      { to: '/data',    label: 'Data' },
    ],
  },
  {
    title: 'Policies',
    links: [
      { to: '/privacy',       label: 'Privacy' },
      { to: '/security',      label: 'Security' },
      { to: '/accessibility', label: 'Accessibility' },
      { to: '/terms',         label: 'Terms of Use' },
    ],
  },
]

export function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer
      role="contentinfo"
      className="w-full border-t border-[var(--color-border)] bg-[var(--color-footer-bg)]"
    >
      <div aria-hidden className="h-px w-full bg-[var(--color-accent)]/60" />
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-5">
        <div className="md:col-span-2">
          <Brand />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[var(--color-text)]">
            Jurisdiction Intelligence - Any Location, Any Border
          </p>
          <p className="mt-4 text-sm text-[var(--color-text)]">
            Built by <MetaPhaseLink />
          </p>
          <p className="mt-6 text-[12px] text-[var(--color-text)]">
            © {year} All Rights Reserved
          </p>
        </div>

        {SECTIONS.map((section) => (
          <div key={section.title}>
            <h2 className="mb-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-[var(--color-text-strong)] font-[var(--font-mono)]">
              {section.title}
            </h2>
            <ul className="space-y-2 text-sm">
              {section.links.map((link) => (
                <li key={link.to}>
                  <a
                    href={link.to}
                    className={[
                      'rounded text-[var(--color-text)] hover:underline underline-offset-2',
                      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-footer-bg)]',
                      'transition-colors',
                    ].join(' ')}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  )
}
